import { Image, Text } from 'platform-components';
import { TEXT_MARKUP_TYPE } from 'platform-components/constants';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

interface Props {
    intl: IntlShape;
    imgKey: string;
    markdownId: string;
    textId: string;
}

const HowToStartModalSlideOne = ({ imgKey, markdownId, textId, intl }: Props) => {
    const imgSrc = intl.formatMessage({ id: imgKey });

    return (
        <div className="how-to-start-modal__column">
            <Image alt="howToStartModal.firstColumn.title" className="how-to-start-modal__image" src={imgSrc} />
            <div className="how-to-start-modal__column-title">
                <Text id={markdownId} size={Text.SIZE.XL} type={TEXT_MARKUP_TYPE.MARKDOWN} weight={Text.WEIGHT.M} />
            </div>
            <div className="how-to-start-modal__column-text">
                <Text id={textId} size={Text.SIZE.XL} type={TEXT_MARKUP_TYPE.MARKDOWN} />
            </div>
        </div>
    );
};

export default injectIntl(HowToStartModalSlideOne);
